import axios from 'axios'
const baseURL = process.env.VUE_APP_BASE_URL
const http = axios.create({
  // baseURL: 'api', //baseURL会在发送请求的时候拼接在url参数的前面
  baseURL: baseURL, //baseURL会在发送请求的时候拼接在url参数的前面
  timeout: 5000
})
// 拦截器
http.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么
    return config
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)
// 响应器
http.interceptors.response.use(
  function(res) {
    return res.data
  },
  function(err) {
    return Promise.reject(err)
  }
)
export default http
